import { PlaySessionTypes } from "../../enums";
import { createEnumCodec } from "../createEnumCodec";

export default createEnumCodec(PlaySessionTypes);